import styled from "@emotion/styled";
import {layout, spacing, nav} from "@atlas-int/tokens";
import { gridAreas as globalGridAreas } from "@atlas-int/tokens/layout";
import { hamburgerMenuContainerHeight } from "../components/navigationBar/styles";

export const gridAreas = {
  header: "HeaderArea",
  body: "BodyArea",
  controls: "ControlsArea",
  footer: "FooterArea",
};

export const gridLines = {
  globalPageLeft: "GlobalPageLeft",
  globalPageRight: "GlobalPageRight",
  globalPageTop: "GlobalPageTop",
  globalPageBottom: "GlobalPageBottom",
  globalControlsLeft: "GlobalControlsLeft",
  globalHeaderBottom: "GlobalHeaderBottom",
  globalFooterTop: "GlobalFooterTop",
  globalFooterBottom: "GlobalFooterBottom",
};

export const PageContentContainer = styled.div`
  grid-area: ${globalGridAreas.content};
  display: grid;
  min-height: 100vh;
  grid-template-rows: [ ${gridLines.globalPageTop}] auto [ ${gridLines.globalPageBottom}];
  grid-template-columns: [ ${gridLines.globalPageLeft}] 1fr [ ${gridLines.globalPageRight}];
  grid-template-areas:
    "${gridAreas.header}"
    "${gridAreas.body}"
    "${gridAreas.footer}";
`;

export const HeaderContainer = styled.div`
  grid-area: ${gridAreas.header};
  background-color: ${nav.background};
  display: flex;
  flex-direction: row;
  height: ${hamburgerMenuContainerHeight};
  justify-content: space-between;
  align-items: center;
  padding: ${spacing[0]} ${layout.pageMargin};
  position: relative;
`;

export const BodyContainer = styled.div`
  grid-area: ${gridAreas.body};
  padding: ${spacing[0]} ${layout.pageMargin} ${spacing[0]} ${spacing[0]};
`;

export const FooterContainer = styled.div`
  grid-area: ${gridAreas.footer};
  display: flex;
  flex-direction: column;
  justify-content: end;
`;
